import { useApi } from '@/api';
import { Link, TableSkeleton } from '@/components';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';
import {
  CryptoIcon,
  Flex,
  WalletAddress,
  DataTable,
  CurrencyValue,
  PercentageValue,
  RelativeDateTime,
  Box
} from '@blockanalitica/ui';

export default function TokenHoldersTable({
  address,
  pagination,
  sorting,
  search
}) {
  const [data, error] = useApi({
    url: `/tokens/${address}/holders/`,
    queryParams: {
      p: pagination.currentPage,
      p_size: pagination.pageSize,
      order: sorting.currentSorting,
      search: search
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    const columns: TableColumn[] = [
      {
        header: 'Wallet',
        getCell: (row) => (
          <WalletAddress
            address={row.wallet_address}
            options={{ sizes: { blockie: '0' } }}
          />
        )
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            Balance
            <CryptoIcon name={data.symbol} address={address} size="0" />
          </Flex>
        ),
        getCell: (row) => <CurrencyValue value={row.balance} />,
        getCellBottom: (row) => (
          <CurrencyValue
            fontSize="-1"
            color="muted"
            value={row[`balance_usd`]}
            options={{ trend: false, iconSize: '0', currency: 'USD' }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'balance'
      },
      {
        header: `Change (1D)`,
        getCell: (row) => (
          <CurrencyValue
            value={row[`balance_change_1d`]}
            options={{ trend: true, iconSize: '0' }}
          />
        ),
        getCellBottom: (row) => (
          <PercentageValue
            fontSize="-1"
            color="muted"
            value={row[`balance_change_percentage`]}
            options={{
              trend: false,
              iconSize: '0',
              nullable: (
                <Box color="muted" fontSize="-1">
                  -
                </Box>
              )
            }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'balance_change_1d'
      },
      {
        header: 'Latest Activity',
        getCell: (row) => (
          <Box color="muted">
            <RelativeDateTime value={row.datetime} />
          </Box>
        ),
        sortingField: 'order_index',
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      }
    ];

    return (
      <DataTable
        rows={data['results']}
        columns={columns}
        getKey={(row) => row.wallet_address}
        rowLinkProps={{
          to: (row) => row.wallet_address,
          // @ts-ignore
          linkComponent: Link
        }}
        sorting={sorting}
        pagination={{
          ...pagination,
          totalRecords: data.count
        }}
      />
    );
  }
  return <TableSkeleton />;
}
